import { jsx as o } from "react/jsx-runtime";
import { TooltipProvider as m } from "@radix-ui/react-tooltip";
import { SimpleTooltip as i } from "./index.es120.js";
const c = ({ children: t, tooltip: r, testId: p }) => {
  let e = t;
  return r && (e = /* @__PURE__ */ o(i, { ...typeof r == "string" ? { title: r, placement: "right" } : r, testId: p, children: t })), /* @__PURE__ */ o(m, { children: e });
};
export {
  c as MenuItemWrapper
};
//# sourceMappingURL=index.es5445.js.map
